import { Divider } from "@mui/material";
import { CompanyTitledPage } from "../../TitledPage";
import CsvFileForm from "./component/csvFileForms/CsvFileForm";
import CsvReadingResultForm from "./component/csvReadingResult/CsvReadingResultForm";
import useCsvImportOrder from "./hook/useCsvImportOrder";
import useCsvReadingResult from "./hook/useCsvReadingResult";
import ResetConfirmDialog from "./component/Dialog/ResetConfirmDialog";
import { useResetConfirmDialog } from "./hook/useResetConfirmDialog";

export default function CsvImportOrderPage({}) {

  const csvImportOrder = useCsvImportOrder();
  const readingResults = useCsvReadingResult(); 
  
  const resetConfirmDialog = useResetConfirmDialog();

  /**
   * 取得結果表示時、動作前に取得結果リセットの確認画面を出して確認を求める。
   * @param onAccepted 確認の結果、承諾された場合の挙動
   * @param onRefused 確認の結果、拒否された場合の挙動
   * @param onSkippedConfirm 確認をスキップした場合(=取引結果が1件も表示されていない場合)の挙動
   */
  const confirmOnHavingReadResults = (
    onAccepted = () => {},
    onRefused = () => {},
    onSkippedConfirm = onAccepted,
  ) => {
 
    if (readingResults.results.length == 0) {
      onSkippedConfirm();  
      return;
    }

    resetConfirmDialog.setOnReset(() => {
      handleResetReadingResults();
      onAccepted();
    });
    resetConfirmDialog.setOnSubmit(() => {
      handleSubmitReadingResults();
    });
    resetConfirmDialog.setOnReturn(() => {
      onRefused();
    });

    resetConfirmDialog.openDialog();
  }

  const handleSubmitFileForm = async () => {

    const submitFunc = async () => { 
      await csvImportOrder.submitCsvImport(
        (resData) => {
          readingResults.renewResults(1, resData);        
        },
        (e) => {alert(`読み込みに失敗しました。\r\n${e.response.data}`)}
      )
    };
    
    confirmOnHavingReadResults(submitFunc);
  };  

  const handleSubmitReadingResults = async () => {
    await readingResults.addOrder(
      () => {
          alert("注文情報を更新しました。");
          readingResults.resetResults();
      },
      (err) => {
        console.log(err);
        alert("注文情報の更新に失敗しました。");
      }
    );    
  }

  const handleResetReadingResults = () => {
    readingResults.resetResults();
  } 
  
  const handleChangeFileForm = async (
    csvFormChangeFunc
  ) => {
    const changeCallback = async () => {
      await csvImportOrder.submitChangeDirectly(
        csvFormChangeFunc,
        (resData) => {
          readingResults.renewResults(1, resData);        
        },
        (e) => {alert(`読み込みに失敗しました。\r\n${e.response.data}`)}
      )
    };

    const changeWithoutConfirmCallback = () => {
      csvImportOrder.setCsvForm(csvFormChangeFunc);
    };

    confirmOnHavingReadResults(
      changeCallback,
      () => {},
      changeWithoutConfirmCallback
    )
  }

  return (
    <CompanyTitledPage title="CSV受注取込">
      <CsvFileForm
        onSubmit={handleSubmitFileForm}
        onChange={handleChangeFileForm}
        csvForm={csvImportOrder.form}
      />
      <Divider sx={{my: 2}} />
      <CsvReadingResultForm
        {...readingResults}
        onSubmitOrder = {() => {
          handleSubmitReadingResults();
          csvImportOrder.resetCsvForm();
        }}
      />
      <ResetConfirmDialog
        {...resetConfirmDialog.dialogParams}
        canSubmit={!readingResults.hasError}
      />
    </CompanyTitledPage>
  );
}